import React from "react";
import { ProjectColors } from "../../../../interfaces/projects";
import ProjectSearchPropertiesList from "../ProjectSearchPropertiesList";
import "./projectSearchResult.scss";

interface ProjectSearchResultProps {
  properties: any;
  colors: ProjectColors;
}

const ProjectSearchResult: React.FC<ProjectSearchResultProps> = ({
  properties,
  colors,
}) => {
  // const getDisponibles = (properties): number =>
  //   properties.filter((x) => x.disponible).length;

  // const getDisponiblesTitle = (properties): string => {
  //   const disponibles = getDisponibles(properties);
  //   const title = `¡ÚLTIMAS ${disponibles} UNIDADES DISPONIBLES!`;
  //   const titleSingle = "¡ÚLTIMA UNIDAD DISPONIBLE!";
  //   const titleEmpty = "No hay unidades disponibles";

  //   return disponibles === 0
  //     ? titleEmpty
  //     : disponibles === 1
  //     ? titleSingle
  //     : title;
  // };

  return (
    <div className="project-search-result">
      {/* <div className="result-title font-bold">
        <div>Resultados: </div>
        <span
          className={`text-uppercase ${
            getDisponibles(properties) > 0 ? "success" : "error"
          }`}
        >
          {getDisponiblesTitle(properties)}
        </span>
      </div> */}

      <ProjectSearchPropertiesList properties={properties} colors={colors} />
    </div>
  );
};

export default ProjectSearchResult;
